export class CashRegisterOpenShiftVendorHandleRequest {
    cashRegisterId?: number;
    requestData?: string;
    responseData?: string;
}  